export const PARTNER_LEVEL_COLORS = {
  "Standard": "#6C757D",          // grey
  "Partner Level 1": "#E85D04",   // orange
  "Partner Level 2": "#C9A02A",   // gold
};

export const LEAD_STATUS_COLORS = {
  "New Lead": "#F4A261",
  Contacted: "#457B9D",
  "Meeting Scheduled": "#457B9D",
  "Sample Delivered": "#7B6DCC",
  "Follow Up Required": "#E76F51",
  Interested: "#E85D04",
  Customer: "#2A9D8F",
  "Lost Opportunity": "#6C757D",
};

export const PRODUCT_BATCH_PREFIX = {
  "Salsa Verde Habanero": "VH",
  "Mango Habanero": "MH",
  "Salsa Verde Taquera": "VT",
  "Salsa Chipotle Taquera": "CT",
};

export const generateBatchNumber = (product, dateStr, seq = 1) => {
  const prefix = PRODUCT_BATCH_PREFIX[product];
  if (!prefix) return "";
  const ymd = (dateStr || new Date().toISOString().slice(0, 10)).replaceAll("-", "");
  return `${prefix}-${ymd}-${String(seq).padStart(2, "0")}`;
};

export const formatEuro = (n) => {
  const v = Number(n || 0);
  return new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
  }).format(v);
};

// 2-decimal precision — for accounting docs (invoices, VAT breakdowns, payment amounts)
export const formatEuro2 = (n) => {
  const v = Number(n || 0);
  return new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(v);
};

export const formatDateEU = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) {
      // Try ISO date only
      const [y, m, day] = iso.split("-");
      if (y && m && day) return `${day}/${m}/${y}`;
      return iso;
    }
    return d.toLocaleDateString("en-GB", {
      day: "2-digit", month: "2-digit", year: "numeric",
    });
  } catch {
    return iso;
  }
};

export const todayISO = () => new Date().toISOString().slice(0, 10);
